/**
 * @generated SignedSource<<7e72711c359356a7de9f60cf25b9860f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespRefetchableSimilarItemsGrid_viewer$data = {
  readonly moreLikeThisItem: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly browseUrl: string | null;
        readonly categoryCode: string | null;
        readonly ecommerceTrackingParams: any | null;
        readonly serviceId: string | null;
        readonly title: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
      } | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null;
    };
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_viewer">;
  readonly " $fragmentType": "PdpRespRefetchableSimilarItemsGrid_viewer";
};
export type PdpRespRefetchableSimilarItemsGrid_viewer$key = {
  readonly " $data"?: PdpRespRefetchableSimilarItemsGrid_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespRefetchableSimilarItemsGrid_viewer">;
};

import PdpRespRefetchableSimilarItemsGrid_viewerRefetchQuery_graphql from './PdpRespRefetchableSimilarItemsGrid_viewerRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "moreLikeThisItem"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "isSimilarityEndpointTestVariant"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": PdpRespRefetchableSimilarItemsGrid_viewerRefetchQuery_graphql
    }
  },
  "name": "PdpRespRefetchableSimilarItemsGrid_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer"
    },
    {
      "alias": "moreLikeThisItem",
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Literal",
          "name": "maxMLItems",
          "value": 40
        },
        {
          "kind": "Literal",
          "name": "seller",
          "value": "EXCLUDE"
        },
        {
          "kind": "Variable",
          "name": "useML",
          "variableName": "isSimilarityEndpointTestVariant"
        }
      ],
      "concreteType": "moreLikeThisItemConnection",
      "kind": "LinkedField",
      "name": "__PdpRespRefetchableSimilarItemsGrid_moreLikeThisItem_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "moreLikeThisItemEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "browseUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "categoryCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ecommerceTrackingParams",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PdpRespSimilarItemsGrid_similarItems"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "9e33ee03e87c59b0ed65a914d8736270";

export default node;
